import { type ReactNode } from 'react'
import { getMenuFooterStatement } from '@/content/printMenu/menuFooterStatements'
import { MenuFooter } from '@/components/printMenu/MenuFooter'
import { cn } from '@/lib/utils'

type MenuPageShellProps = {
  children: ReactNode
  pageNumber: number
  totalPages: number
  className?: string
  bare?: boolean
  hideFooter?: boolean
}

export function MenuPageShell({
  children,
  pageNumber,
  totalPages,
  className,
  bare = false,
  hideFooter = false,
}: MenuPageShellProps) {
  const footerStatement = getMenuFooterStatement(pageNumber)

  return (
    <article
      className={cn('menu-page grid grid-rows-[1fr_auto]', className)}
      aria-label={`Page ${pageNumber} of ${totalPages}`}
    >
      <div
        className={cn(
          'flex min-h-0 flex-col overflow-hidden',
          !bare && 'px-[18mm] pt-[16mm] pb-[6mm]',
        )}
      >
        {children}
      </div>
      {!hideFooter ? <MenuFooter statement={footerStatement} /> : null}
    </article>
  )
}
